import { render, staticRenderFns } from "./EditPaymentMethod.modal.vue?vue&type=template&id=94770b22&scoped=true&"
import script from "./EditPaymentMethod.modal.vue?vue&type=script&lang=js&"
export * from "./EditPaymentMethod.modal.vue?vue&type=script&lang=js&"
import style0 from "./EditPaymentMethod.modal.vue?vue&type=style&index=0&id=94770b22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94770b22",
  null
  
)

export default component.exports